import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Word/line mask reveal — wrap in overflow-hidden, animate y
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.12em]">
    <motion.span
      className={`block leading-[1.08] ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-mono text-xs md:text-sm uppercase tracking-[0.28em] text-vt-gold/80 ${className}`}
  >
    {children}
  </span>
);

export const Hairline = ({ className = "" }) => (
  <div className={`vt-hairline w-full ${className}`} />
);
